import clsx from 'clsx'

const statusStyles = {
  // Booking statuses
  'pending': { bg: 'bg-yellow-100', text: 'text-yellow-800', label: '报价中' },
  'confirmed': { bg: 'bg-purple-100', text: 'text-purple-800', label: '已报价' },
  'rejected': { bg: 'bg-red-100', text: 'text-red-800', label: '已拒绝' },
  'completed': { bg: 'bg-green-100', text: 'text-green-800', label: '已完成' },
  'cancelled': { bg: 'bg-gray-100', text: 'text-gray-800', label: '已取消' },
  
  // Issue statuses
  'Open': { bg: 'bg-red-100', text: 'text-red-800', label: '待处理' },
  'In Progress': { bg: 'bg-yellow-100', text: 'text-yellow-800', label: '处理中' },
  'Resolved': { bg: 'bg-green-100', text: 'text-green-800', label: '已解决' },
  'Closed': { bg: 'bg-gray-100', text: 'text-gray-800', label: '已关闭' },
  
  // Account status
  'Active': { bg: 'bg-green-100', text: 'text-green-800', label: '正常' },
  'Frozen': { bg: 'bg-red-100', text: 'text-red-800', label: '冻结' },
  
  // Finance status
  'Approved': { bg: 'bg-green-100', text: 'text-green-800', label: '已批准' },
  'Rejected': { bg: 'bg-red-100', text: 'text-red-800', label: '已拒绝' },
}

export default function StatusBadge({ status, className }) {
  const style = statusStyles[status] || { bg: 'bg-gray-100', text: 'text-gray-800', label: status }

  return (
    <span className={clsx(
      'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
      style.bg,
      style.text,
      className
    )}>
      {style.label}
    </span>
  )
}
